import { useEffect, useState } from "react";

export const useHasCameraDevice = () => {
  const [hasCameraDevice, setHasCameraDevice] = useState(false);

  useEffect(() => {
    navigator.mediaDevices
      ?.enumerateDevices()
      .then((devices) => {
        setHasCameraDevice(devices.some((d) => d.kind === "videoinput"));
      })
      .catch(() => setHasCameraDevice(false));
  }, []);

  return hasCameraDevice;
};
